import { Ng2StateDeclaration } from '@uirouter/angular';

export const BUSINESS_INSIGHTS_MODULE_STATE: Ng2StateDeclaration = {
  name: 'dice.business-insights.**',
  url: '/business-insights',
  loadChildren: () => import('@business-insights/app/business-insights.module').then((m) => m.BusinessInsightsModule),
};
export const APP_STATES = [BUSINESS_INSIGHTS_MODULE_STATE];
